import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import {
  Row,
  Cell,
  DeletedFlowCell,
  DeletedFlowAlert,
  DeleteButtonContainer,
  DeleteButton,
} from '../styled';
import type { ColumnWidths } from '../types';

interface DeletedFlowRowProps {
  flowMeta: any;
  removeFlow: (flowId: string) => void;
  columnWidths: ColumnWidths;
}

const DeletedFlowRow: React.FC<DeletedFlowRowProps> = ({ flowMeta, removeFlow, columnWidths }) => {
  const { nameColumnWidth, initColumnWidth, successColumnWidth } = columnWidths;

  const handleRemoveFlow = () => {
    removeFlow(String(flowMeta.id));
  };

  return (
    <Row>
      <DeletedFlowCell $width={nameColumnWidth}>
        <DeletedFlowAlert type="error" message="This flow has been deleted" banner />
      </DeletedFlowCell>
      <Cell $width={initColumnWidth} />
      <Cell $width={successColumnWidth} style={{ justifyContent: 'flex-end' }}>
        <DeleteButtonContainer>
          <DeleteButton
            type="text"
            size="large"
            icon={<DeleteOutlined />}
            onClick={handleRemoveFlow}
            danger
            title="Remove this flow from the dashboard"
          />
        </DeleteButtonContainer>
      </Cell>
    </Row>
  );
};

export default DeletedFlowRow;
